import { render } from "./NewsVertical.vue?vue&type=template&id=d16b8c52&scoped=true"
import script from "./NewsVertical.vue?vue&type=script&lang=js"
export * from "./NewsVertical.vue?vue&type=script&lang=js"

import "./NewsVertical.vue?vue&type=style&index=0&id=d16b8c52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d16b8c52"

export default script